import React from 'react';
import PropTypes from 'prop-types';
import LinkGroupHeading from './styled/LinkGroupHeading';
import { Expand, Minus, Plus } from '../../../common/css_global/mobile/utils.css';
import { Mobile } from '../../MediaQuery';
import { useUrlBuilder } from '../../../hooks/useUrlBuilder';

const LinkGroupTitle = ({ title, showSection, toggleSection, index }) => {
  const { withCDN } = useUrlBuilder();
  return (
    <LinkGroupHeading expand={showSection} onClick={() => toggleSection(index)}>
      {title}
      <Mobile>
        <Expand>
          {showSection ? (
            <Minus src={withCDN('mkt/icon/minus_white.png')} />
          ) : (
            <Plus src={withCDN('mkt/icon/plus_white.png')} />
          )}
        </Expand>
      </Mobile>
    </LinkGroupHeading>
  );
};

LinkGroupTitle.propTypes = {
  title: PropTypes.string.isRequired,
  index: PropTypes.number,
  toggleSection: PropTypes.func,
  showSection: PropTypes.bool,
};

export default LinkGroupTitle;
